import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";
import {ConfirmController} from "../../modals/confirm";

export class Type {

  key: string;
  label: string;
  iconClass: string;

  static buildType(key: string, label: string, iconClass: string) {
    var result = new Type();
    result.key = key;
    result.label = label;
    result.iconClass = iconClass
    return result;
  }

  static idGen = 0;
  static createDummyType() {
    var result = new Type();
    result.label = "Label " + Type.idGen++;
    result.iconClass = "glyphicon glyphicon-asterisk";
    return result;
  }



}


export class TypeList extends Array<Type> {

  static buildCompleteTypeList(): TypeList {
    var result = new TypeList();

    result.push(Type.buildType("alcohol_free", "CREATE.ALCOHOL_TYPE_FREE", "ot-icon-alcohol-free"));
    result.push(Type.buildType("byob", "CREATE.ALCOHOL_TYPE_BYOB", "ot-icon-byob"));
    result.push(Type.buildType("host_provides", "CREATE.ALCOHOL_TYPE_HOST_PROVIDES", "ot-icon-beer-and-wine"));
    result.push(Type.buildType("vegetarian", "CREATE.DIET_TYPE_VEGETARIAN", "ot-icon-vegetarian"));
    result.push(Type.buildType("vegan", "CREATE.DIET_TYPE_VEGAN", "ot-icon-vegan"));
    result.push(Type.buildType("gluten_free", "CREATE.DIET_TYPE_GLUTEN_FREE", "ot-icon-gluten-free"));
    result.push(Type.buildType("kosher", "CREATE.DIET_TYPE_KOSHER", "ot-icon-kosher"));

    return result;
  }

  constructor() {
    super();
  }
}


export class TypeListDirective {

  template = TPL.contentDirectives.typeList;
  scope = {
    params: "=params"
  };

  link;

  constructor() {

    this.link = (scope, el, attrs) => {

      var typeList = TypeList.buildCompleteTypeList();

      scope.vm = {
        typeList: typeList
      };
    }
  }

  static factory() {
    return () => new TypeListDirective();
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/type.ts
 **/